// from https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/icon/src/create-icon.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Children, createContext, useContext } from 'react';
import { forwardRef, Icon, useBreakpointValue } from '@chakra-ui/react';
import { isObject } from '@chakra-ui/shared-utils';
export const iconSizeContext = /*#__PURE__*/ createContext(undefined);
const createIcon = (options)=>{
    const { viewBox = '0 0 24 24', displayName, defaultProps = {} } = options;
    const pathSmall = Children.toArray(options.pathSmall);
    const pathMedium = Children.toArray(options.pathMedium);
    const Comp = forwardRef((_param, ref)=>{
        var { size } = _param, props = _object_without_properties(_param, [
            "size"
        ]);
        const iconSizeContextValue = useContext(iconSizeContext);
        const sizeToUse = iconSizeContextValue || size;
        // Handle `{base: 'small', md: 'medium'}` kind of notation
        const iconSize = useBreakpointValue(isObject(sizeToUse) ? sizeToUse : {
            base: sizeToUse
        });
        return /*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({
            ref: ref,
            viewBox: viewBox
        }, defaultProps, props), {
            children: iconSize === 'medium' ? pathMedium : pathSmall
        }));
    });
    Comp.displayName = displayName;
    return Comp;
};
export { createIcon };

//# sourceMappingURL=utils.js.map